export default {
  hasFeature: state => feature => (state.features ? state.features.some(f => f === feature) : false),
}
